// import './style.less';

export default function($log, ApiClass) {
  'ngInject';

  const vm = this;
  $log.debug('Course Component Activated');
  vm.loaded = false;
  vm.$onInit = activate;

  function activate() {
    vm.error = {};
    if (vm.externalCourse) {
      vm.loaded = true;
      vm.course = vm.externalCourse;
      return;
    }

    if (vm.course) {
      return (vm.loaded = true);
    }

    ApiClass.coursesIdGet({ id: vm.courseId })
      .then(courseResponse => {
        $log.debug('Course Data:', courseResponse.data.course);
        vm.course = courseResponse.data.course;
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: error.status,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/course/controller.js